import { render, staticRenderFns } from "./DiningTable.vue?vue&type=template&id=2a99f2e8"
import script from "./DiningTable.vue?vue&type=script&lang=js"
export * from "./DiningTable.vue?vue&type=script&lang=js"
import style0 from "./DiningTable.vue?vue&type=style&index=0&id=2a99f2e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports